import Footer from "./Footer";
import Header from "./header";
import TopSection from "./TopSection";
import StepByStep from "./StepByStep";
import FAQ from "./faq";
import Banner from "./Banner";
import LastSection from "./LastSection";
import QuickStart from "./QuickStart";
import Content from "./Content";
import ThumbsUp from "./ThumbsUp";

export {
	Footer,
	Header,
	TopSection,
	StepByStep,
	FAQ,
	Banner,
	LastSection,
	QuickStart,
	Content,
	ThumbsUp
}